<template>
  <Window
    title="Social"
    window-name="social"
    :icon-src="require('@/assets/task-bar-icons/icon-social.svg')"
  >
    <div class="container">
      <div class="content" v-if="postRepeated">
        <SocialPost
          v-for="post in postRepeated"
          :key="post.id"
          :gameStateKey="post.gameStateKey"
          :username="post.username"
          :content="post.content"
          :image="post.image"
          :replies="post.replies"
        />
        <BottomLoading @appear="loadMorePosts" />
      </div>
      <div class="loader-container" v-else>
        <Loading :light="true" />
      </div>
    </div>
  </Window>
</template>

<script>
import SocialPost from "./SocialPost";
import BottomLoading from "./BottomLoading";
import Window from "@/components/shared/Window";
import Loading from "@/components/shared/Loading";
import gameStateKeys from "@/assets/gameStateKeys";
import gameStateStore from "@/stores/GameStateStore";

export default {
  name: "SocialWindow",
  components: { Window, SocialPost, BottomLoading, Loading },
  data() {
    return {
      postData: undefined,
      postRepeats: 0,
    };
  },
  computed: {
    posts() {
      if (this.postData) {
        let result = [];

        for (const stateKey of gameStateKeys) {
          result.push(
            this.postData[stateKey].map(item => ({
              ...item,
              gameStateKey: stateKey,
            }))
          );

          if (stateKey === gameStateStore.stateKey) break;
        }

        result = result.reverse().flat();

        return result;
      }
      return undefined;
    },
    postRepeated() {
      let result = this.posts;

      if (result)
        for (let i = 0; i < this.postRepeats; i++)
          result = result.concat(
            this.posts.map(item => ({ ...item, id: item.id + i }))
          );

      return result;
    },
  },
  methods: {
    loadMorePosts() {
      setTimeout(() => {
        this.postRepeats++;
      }, 1000);
    },
  },
  async mounted() {
    const socialJsons = await Promise.all(
      (
        await Promise.all(
          gameStateKeys.map(key =>
            Promise.all([
              fetch(`/game-content/${key}/social/main.json`),
              Promise.resolve(key),
            ])
          )
        )
      )
        .filter(([response]) => response.ok)
        .map(([response, key]) =>
          Promise.all([response.json(), Promise.resolve(key)])
        )
    );

    this.postData = {};

    socialJsons.map(([value, key]) => {
      this.postData[key] = value;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/mixins";

.container {
  @include style-scrollbars(rgba(white, 0.4), rgb(21, 32, 43));

  height: 100%;
  width: 100%;
  background-color: rgb(21, 32, 43);
  overflow: auto;

  .content {
    margin: auto;
    max-width: 598px;

    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: rgb(56, 68, 77);

    border-right-style: solid;
    border-right-width: 1px;
    border-right-color: rgb(56, 68, 77);
  }

  .loader-container {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
